import React from 'react';
import { Clock, Globe, Zap } from 'lucide-react';
export const About = () => {
  return <section id="about" className="py-20 bg-white" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-17">About Me</h2>
          <div className="w-20 h-1 bg-indigo-600 mx-auto" data-id="element-18"></div>
        </div>
        <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-19">
          <div className="md:w-2/5" data-id="element-20">
            <div className="relative" data-id="element-21">
              <div className="absolute -top-4 -left-4 w-full h-full border-2 border-indigo-600 rounded-lg z-0" data-id="element-22"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rnk8rZ5Tyk8xcGpbNeNaVD/IMG_8552.png" alt="Multiple Dredget app screens showing various features" className="rounded-lg shadow-md relative z-10 w-full h-auto object-cover" data-id="element-23" />
            </div>
          </div>
          <div className="md:w-3/5" data-id="element-24">
            <h3 className="text-2xl font-bold mb-4" data-id="element-25">
              Hi, I'm Oto Protsin – a creative designer, UX/UI and visual
              creator
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-26">
              I have a strong background in print, digital design, and video
              production. My work bridges practical precision with visual
              thinking – from crafting user experiences and brand visuals to
              preparing production-ready files.
            </p>
            <div className="mb-6" data-id="element-27">
              <h4 className="font-bold mb-2" data-id="element-28">I have experience in:</h4>
              <ul className="list-disc pl-5 text-gray-600 space-y-2" data-id="element-29">
                <li data-id="element-30">UX/UI design (Figma, Webflow, user flows, prototypes)</li>
                <li data-id="element-31">Print production (digital print, prepress, cutting)</li>
                <li data-id="element-32">
                  Video editing & image modification (After Effects, Photoshop)
                </li>
              </ul>
            </div>
            <div className="mb-8" data-id="element-33">
              <h4 className="font-bold mb-2" data-id="element-34">Artistic Philosophy</h4>
              <p className="text-gray-600" data-id="element-35">
                I believe great design lives where form meets purpose — and
                every detail matters. I approach each project with curiosity and
                focus – to find a solution that works and looks great. My
                strength lies in transforming simple ideas into meaningful and
                aesthetic solutions that resonate both functionally and
                emotionally.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-36">
              <div className="flex flex-col items-center p-4 bg-gray-50 rounded-lg" data-id="element-37">
                <Clock className="text-indigo-600 mb-2" size={28} data-id="element-38" />
                <h4 className="font-bold" data-id="element-39">2+ Years</h4>
                <p className="text-sm text-gray-500 text-center" data-id="element-40">
                  Of Experience
                </p>
              </div>
              <div className="flex flex-col items-center p-4 bg-gray-50 rounded-lg" data-id="element-41">
                <Zap className="text-indigo-600 mb-2" size={28} data-id="element-42" />
                <h4 className="font-bold" data-id="element-43">6+ Projects</h4>
                <p className="text-sm text-gray-500 text-center" data-id="element-44">Completed</p>
              </div>
              <div className="flex flex-col items-center p-4 bg-gray-50 rounded-lg" data-id="element-45">
                <Globe className="text-indigo-600 mb-2" size={28} data-id="element-46" />
                <h4 className="font-bold" data-id="element-47">3+ Clients</h4>
                <p className="text-sm text-gray-500 text-center" data-id="element-48">Worldwide</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};